import type { LayoutConfig } from '@/utils/dealCalculations'
import {
  DEFAULT_BONUS_Y,
  DEFAULT_DESCRIPTION_Y,
  DEFAULT_LOYALTY_Y,
  DEFAULT_NEGOTIATION_Y,
  DEFAULT_PAYMENT_Y,
  DEFAULT_PRICE_Y,
  DEFAULT_PROJECT_TYPE_Y,
  DEFAULT_SUPPORT_HOURS_Y,
  DEFAULT_TITLE_Y,
} from '@/utils/dealCalculations'

/** Normaliza layout legado (0–1) e chaves antigas do CRM para o sistema 0–100. */
export function normalizeInitialLayout(initialLayout?: LayoutConfig): LayoutConfig {
  const raw = (initialLayout || {}) as unknown as Record<string, unknown>

  const base: Record<string, unknown> = {
    leftBlockWidth: raw.leftBlockWidth !== undefined ? raw.leftBlockWidth : 35,
    dividerX: raw.dividerX !== undefined ? raw.dividerX : 35,
    titleY: raw.titleY !== undefined ? raw.titleY : DEFAULT_TITLE_Y,
    projectTypeY:
      raw.projectTypeY !== undefined
        ? raw.projectTypeY
        : raw.descY !== undefined
          ? raw.descY
          : DEFAULT_PROJECT_TYPE_Y,
    descriptionY:
      raw.descriptionY !== undefined
        ? raw.descriptionY
        : raw.descY !== undefined
          ? (raw.descY as number) + 6
          : DEFAULT_DESCRIPTION_Y,
    supportHoursY:
      raw.supportHoursY !== undefined ? raw.supportHoursY : DEFAULT_SUPPORT_HOURS_Y,
    bonusY: raw.bonusY !== undefined ? raw.bonusY : DEFAULT_BONUS_Y,
    priceY: raw.priceY !== undefined ? raw.priceY : DEFAULT_PRICE_Y,
    paymentY: raw.paymentY !== undefined ? raw.paymentY : DEFAULT_PAYMENT_Y,
    loyaltyY:
      raw.loyaltyY !== undefined
        ? raw.loyaltyY
        : raw.bottomY !== undefined
          ? raw.bottomY
          : DEFAULT_LOYALTY_Y,
    negotiationY:
      raw.negotiationY !== undefined ? raw.negotiationY : DEFAULT_NEGOTIATION_Y,
    planTitleY:
      raw.planTitleY !== undefined
        ? raw.planTitleY
        : raw.titleY !== undefined
          ? raw.titleY
          : 2.7,
    serviceBlockStartY:
      raw.serviceBlockStartY !== undefined
        ? raw.serviceBlockStartY
        : raw.servicesY !== undefined
          ? raw.servicesY
          : 10,
    serviceBlockX:
      raw.serviceBlockX !== undefined
        ? raw.serviceBlockX
        : raw.servicesCol1X !== undefined
          ? raw.servicesCol1X
          : 38,
    serviceBlockGap:
      raw.serviceBlockGap !== undefined
        ? raw.serviceBlockGap
        : raw.servicesCol2X !== undefined
          ? raw.servicesCol2X
          : 68,
    categoryCoords: raw.categoryCoords || {},
  }

  if (
    typeof base.leftBlockWidth === 'number' &&
    base.leftBlockWidth > 0 &&
    base.leftBlockWidth <= 1
  ) {
    base.leftBlockWidth = base.leftBlockWidth * 100
    base.dividerX = base.leftBlockWidth
    base.titleY = (base.titleY as number) * 100
    base.projectTypeY = (base.projectTypeY as number) * 100
    base.descriptionY = (base.descriptionY as number) * 100
    base.supportHoursY = (base.supportHoursY as number) * 100
    base.bonusY = (base.bonusY as number) * 100
    base.priceY = (base.priceY as number) * 100
    base.paymentY = (base.paymentY as number) * 100
    base.loyaltyY = (base.loyaltyY as number) * 100
    base.negotiationY = (base.negotiationY as number) * 100
    base.planTitleY = (base.planTitleY as number) * 100
    base.serviceBlockStartY = (base.serviceBlockStartY as number) * 100
    base.serviceBlockX = (base.serviceBlockX as number) * 100
    base.serviceBlockGap = (base.serviceBlockGap as number) * 100
  }

  if (base.categoryCoords && typeof base.categoryCoords === 'object') {
    const convertedCoords: Record<string, { x: number; y: number }> = {}
    for (const [key, val] of Object.entries(
      base.categoryCoords as Record<string, { x?: number; y?: number }>,
    )) {
      if (val && typeof val === 'object') {
        let cx = val.x ?? 0
        let cy = val.y ?? 0
        if (cx > 0 && cx <= 1) cx = cx * 100
        if (cy > 0 && cy <= 1) cy = cy * 100
        convertedCoords[key] = { x: cx, y: cy }
      }
    }
    base.categoryCoords = convertedCoords
  }

  return base as unknown as LayoutConfig
}
